<template>
    <div class="block-cnt">
        <div class="ex-single">
            <div class="block-row">
                <label class="row-lb font500">{{$t('voucher.general.no')}}</label>
                <div class="row-cnt">{{voucher.voucher_number}}</div>
            </div>

            <div class="block-row">
                <label class="row-lb font500">{{$t('voucher.general.middle_classification')}}</label>
                <div class="row-cnt text-orange-sub font500 d-flex align-items-center">
                    {{voucher.voucher_type_name}}
                    <i
                        class="icon-picture ml-4"
                        v-if="voucher.has_file"
                        @click="showPdf()"
                    ></i>
                    <i
                        class="icon-pencil ml-2"
                        v-if="voucher.has_file"
                        :style="{
                            opacity: voucher.box_file_id != null && voucher.box_file_id !== '' ? 1 : 0.35,
                            pointerEvents: voucher.box_file_id != null && voucher.box_file_id !== '' ? 'auto' : 'none'
                        }"
                        @click="voucher.box_file_id != null && voucher.box_file_id !== '' && $emit('select-update-files')"
                    ></i>
                </div>
            </div>

            <div class="block-row">
                <label class="row-lb font500">{{$t('voucher.general.transaction_date')}}</label>
                <div
                    class="row-cnt"
                >{{dateUtils.formatDateYYYYMMDD(voucher.transaction_date)}}({{dateUtils.getDay(voucher.transaction_date)}})</div>
            </div>

            <div class="block-row">
                <label class="row-lb font500">{{$t('voucher.general.use')}}</label>
                <div class="row-cnt">{{voucher.use}}</div>
            </div>

            <div class="block-row">
                <label class="row-lb font500">{{$t('voucher.general.service')}}</label>
                <div class="row-cnt">{{utils.getVoucherService(voucher.service)}}</div>
            </div>

            <div class="block-row">
                <label class="row-lb font500">{{$t('voucher.general.account_name')}}</label>
                <div class="row-cnt">{{voucher.account_name}}</div>
            </div>

            <div class="block-row" v-if="utils.isEmptyObj(tourInfo) || tourInfo.tour_type == constants.TourType.international.id">
                <label class="row-lb font500">{{$t('voucher.general.city')}}</label>
                <div class="row-cnt">{{voucher.city}}</div>
            </div>

            <div class="block-row">
                <label class="row-lb font500">{{$t('voucher.general.personal')}}</label>
                <div class="row-cnt">
                    {{voucher.personal}}
                    <span v-if="voucher.personal">{{$t('tour.person')}}</span>
                </div>
            </div>

            <div class="block-row">
                <label class="row-lb font500">{{$t('voucher.general.unit_price')}}</label>
                <div
                    class="row-cnt"
                >{{utils.formatPrice(voucher.unit_price, voucher.currency_id)}}{{ voucher.unit_price ? utils.getCurrencyName(voucher.currency_id) : ''}}</div>
            </div>

            <div class="block-row">
                <label class="row-lb font500">{{$t('voucher.general.amount')}}</label>
                <div
                    class="row-cnt"
                >{{utils.formatPrice(voucher.total_amount, voucher.currency_id)}}{{utils.getCurrencyName(voucher.currency_id)}}</div>
            </div>

            <div class="block-row">
                <label class="row-lb font500">{{$t('voucher.general.category')}}</label>
                <div
                    class="row-cnt text-orange font500 d-flex align-items-center"
                >{{utils.getInOutType(voucher.type)}}</div>
            </div>

            <div class="block-row">
                <label class="row-lb font500">{{$t('voucher.general.tax_rate')}}</label>
                <div
                    class="row-cnt text-orange font500 d-flex align-items-center"
                >{{utils.getTaxRate(voucher.tax_rate)}}</div>
            </div>

            <div class="block-row">
                <label class="row-lb font500">{{$t('voucher.general.tax_free')}}</label>
                <div class="row-cnt text-orange font500 d-flex align-items-center">
                    {{utils.getTaxExempt(voucher.tax_exempt)}}
                </div>
            </div>

            <div v-if="voucher.tax_rate==3">
                <div v-for="otherTax in voucher.other_tax" :key="otherTax.id" class="block-row">
                    <label class="row-lb font500"></label>
                    <div class="row-cnt w-100">
                        <div class="ex-sub-block">
                            <div class="block-row">
                                <div class="d-flex fs-15 w-100">
                                    <div class="w-re" style="word-break: break-all;">{{otherTax.description}}</div>
                                    <div
                                        class="w-65 text-right" style="word-break: break-all;"
                                    >{{utils.formatPrice(otherTax.price, voucher.currency_id)}}{{utils.getCurrencyName(voucher.currency_id)}}</div>
                                    <div class="w-65 text-right" style="word-break: break-all;">{{utils.getTaxRate(otherTax.tax_rate)}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="block-row">
                <label class="row-lb font500">{{$t('voucher.general.target_flag')}}</label>
                <div class="row-cnt">
                    <label class="checkbox-custom">
                        <input type="checkbox" disabled="disabled" name v-model="voucher.target_flag" />
                        <span class="checkmark"></span>
                        <span class="font30 fs-18">{{$t('voucher.general.target')}}</span>
                    </label>
                </div>
            </div>

            <div class="block-row">
                <label class="row-lb font500">{{$t('voucher.general.billed_flag')}}</label>
                <div class="row-cnt">
                    <label class="checkbox-custom">
                        <input type="checkbox" disabled="disabled" name v-model="voucher.billed_flag" />
                        <span class="checkmark"></span>
                        <span class="font30 fs-18">{{$t('voucher.general.target')}}</span>
                    </label>
                </div>
            </div>

            <div class="block-row">
                <label class="row-lb font500">{{$t('voucher.general.note')}}</label>
                <div class="row-cnt">{{voucher.note}}</div>
            </div>
        </div>
        <!-- Pdf viewer -->
        <pdf :voucher="voucher" v-if="showPdfViewer" :closePdf="closePdf"></pdf>
    </div>
</template>
<script>
import Utils from "@/helpers/utils";
import DateUtils from '@/helpers/dateUtils';
import { Constants } from "@/helpers/constants";

import StorageService from "@/services/common/storage.service";

import Pdf from "@/views/components/sp/Voucher/PdfViewer";

export default {
    name: "Temp_1",
    components: {
        pdf: Pdf,
    },
    props: {
        voucher: {},
    },
    data () {
        return {
            utils: Utils,
            dateUtils: DateUtils,
            constants: Constants,
            tourInfo: "",
            showPdfViewer: false,
        };
    },
    mounted () {
        this.tourInfo = JSON.parse(StorageService.getTour());
    },
    methods: {
        closePreprocessingUpload () {
            this.$emit("update:backHandler", () => {
                this.$router.go(-1);
            });
            this.$emit("enableButton");
            this.$emit("update:actionHandler", () => {});
            this.showPreprocessingUpload = false;
        },
        showPdf () {
            this.showPdfViewer = true;
        },
        closePdf () {
            this.showPdfViewer = false;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/sp/Voucher/Details/Temp_1.vue